import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedIcon } from '../../commons/AnimatedIcon';
import WaitingIconLight from '../../../assets/images/lottieIcons/waiting/waiting.light.json';
import WaitingIconDark from '../../../assets/images/lottieIcons/waiting/waiting.dark.json';

export const OrderProcessing = () => {
  const { t } = useTranslation();

  return (
    <div className="order-processing">
      <div className="success_page__icon-container">
        <AnimatedIcon
          lightIcon={WaitingIconLight}
          darkIcon={WaitingIconDark}
          className="success_page__icon-container__icon"
          loop
        />
      </div>
      <div className="order-processing-message">{t('success.yourServiceProcessing')}</div>
    </div>
  );
};
